<script>
  import { X, FileText, Calendar, User } from 'lucide-svelte';
  import { _ } from '../lib/i18n.js';
  import { sanitizeHtml } from '../lib/sanitizeHtml.js';

  /** @type {{ report: Object|null, onClose: () => void }} */
  let { report = null, onClose } = $props();

  // The backend already sanitizes htmlContent; sanitize again at the {@html}
  // sink as defense in depth.
  let safeHtml = $derived(report ? sanitizeHtml(report.htmlContent) : '');
</script>

{#if report}
  <div
    class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
    role="dialog"
    aria-modal="true"
    onclick={(e) => e.target === e.currentTarget && onClose()}
    onkeydown={(e) => e.key === 'Escape' && onClose()}
  >
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col">
      <!-- Header -->
      <div class="p-6 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div class="p-3 bg-linear-to-br from-primary-500 to-primary-600 rounded-xl">
            <FileText size={24} class="text-white" />
          </div>
          <div>
            <h2 class="text-xl font-bold text-gray-900 dark:text-white">{report.name}</h2>
            <div class="flex items-center space-x-4 text-sm text-gray-500 dark:text-gray-400 mt-1">
              {#if report.customerName}
                <span class="flex items-center space-x-1">
                  <User size={14} />
                  <span>{report.customerName}</span>
                </span>
              {/if}
              <span class="flex items-center space-x-1">
                <Calendar size={14} />
                <span>{new Date(report.createdAt).toLocaleDateString('it-IT')}</span>
              </span>
            </div>
          </div>
        </div>
        <button
          class="p-2 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          onclick={onClose}
          aria-label={$_('common.close')}
        >
          <X size={24} />
        </button>
      </div>

      <!-- Content -->
      <div class="flex-1 overflow-y-auto p-6">
        <article class="prose prose-gray dark:prose-invert max-w-none prose-headings:text-gray-900 dark:prose-headings:text-white prose-p:text-gray-700 dark:prose-p:text-gray-300 prose-a:text-primary-600 dark:prose-a:text-primary-400 prose-code:bg-gray-100 dark:prose-code:bg-gray-700 prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-pre:bg-gray-100 dark:prose-pre:bg-gray-900 prose-pre:border prose-pre:border-gray-200 dark:prose-pre:border-gray-700">
          {@html safeHtml}
        </article>
      </div>

      <!-- Footer -->
      <div class="p-4 border-t border-gray-200 dark:border-gray-700 flex justify-end">
        <button
          class="btn btn-secondary"
          onclick={onClose}
        >
          {$_('common.close')}
        </button>
      </div>
    </div>
  </div>
{/if}
